import { Link } from '@wistia/vhs';
import { styled } from 'styled-components';
import { breakpoints } from '~/singlePageApp/screens/LiveStreamScreen/shared/breakpoints';
import { externalLinks } from '~/externalLinks';

const Main = styled.main`
  align-items: center;
  background-color: ${({ theme }) => theme.color.grey200};
  display: flex;
  justify-content: center;
  min-block-size: 100vh;
`;

const UnsupportedMessage = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.color.grey900};
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => `${theme.font.family.default}`};
  justify-content: center;
  line-height: 1.5;

  & > * {
    margin: 0;
  }

  & > * + * + * {
    margin-block-start: 1.5rem;
  }
`;

const TopLine = styled.h2`
  font-size: clamp(1.75rem, calc(1rem + 1.5vw), 2.5rem);
  font-weight: 300;
`;

const BottomLine = styled.h1`
  font-size: clamp(2.25rem, calc(1rem + 3vw), 3.375rem);
  font-weight: 300;
  text-align: center;

  @media (max-width: ${breakpoints.largeTablet}rem) {
    font-size: 2.25rem;
  }
`;

const DownloadContainer = styled.div`
  align-items: center;
  background: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 10%);
  display: flex;
  flex-wrap: wrap;
  font-weight: 400;
  gap: 1rem 1.25rem;
  max-width: min(35rem, 75%);
  padding: 1.5rem;
  text-align: left;

  & > :first-child {
    flex: 1;
    font-size: 1.5rem;
    margin: auto;
    max-width: 22ch;
  }

  @media (max-width: ${breakpoints.largeTablet}rem) {
    text-align: center;

    & > :last-child {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
`;

const DownloadBrowser = styled.a`
  align-items: center;
  border: 0.0625rem solid ${({ theme }) => theme.color.grey300};
  border-radius: 0.5rem;
  display: flex;
  flex-direction: row;
  height: 5rem;
  justify-content: space-between;
  padding: 1rem;
  text-decoration: none;
  width: 10.25rem;
  margin-bottom: 0.5rem;

  &:hover,
  &:focus {
    text-decoration: underline;
  }

  @media (max-width: ${breakpoints.largeTablet}rem) {
    margin: 1rem;
  }
`;

const MoreInfo = styled.div`
  line-height: 4;
  margin-block-start: 0;

  @media (max-width: ${breakpoints.largeTablet}rem) {
    font-size: 0.75rem;
  }
`;

export const UnsupportedBrowser = ({ isMobile }) => {
  return (
    <Main>
      <UnsupportedMessage>
        <TopLine>We&apos;re sorry,</TopLine>
        <BottomLine>This {isMobile ? 'device' : 'browser'} isn&apos;t supported.</BottomLine>
        <DownloadContainer>
          <div>
            To enjoy our app, please use Google Chrome or Firefox{' '}
            {isMobile ? 'on a laptop or desktop device' : ''}
          </div>
          <div>
            <DownloadBrowser
              alt="Link to download Chrome"
              href="https://www.google.com/chrome/downloads/"
            >
              <img
                alt=""
                src="https://www.google.com/chrome/static/images/chrome-logo.svg"
              />
              Chrome
            </DownloadBrowser>
            <DownloadBrowser
              alt="Link to download Firefox"
              href="https://www.mozilla.org/en-US/firefox/new/"
            >
              <img
                src="https://www.mozilla.org/media/protocol/img/logos/firefox/logo.fedb52c912d6.svg"
                width="40"
                height="45"
                alt=""
              />
              Firefox
            </DownloadBrowser>
          </div>
        </DownloadContainer>
        <MoreInfo>
          For more detailed information&nbsp;
          <Link
            href={externalLinks.support}
            type="external"
          >
            click here.
          </Link>
        </MoreInfo>
      </UnsupportedMessage>
    </Main>
  );
};
